import { GET_ALL_SESSIONS_FAILURE, GET_ALL_SESSIONS_SUCCESS, GET_SESSION_DATA_FAILURE, GET_SESSION_DATA_SUCCESS, RAG_UPLOAD_FAILURE, RAG_UPLOAD_SUCCESS, TYPE_CHAT_FAILURE, TYPE_CHAT_RESET, TYPE_CHAT_STREAM_META, TYPE_CHAT_STREAM_START, TYPE_CHAT_STREAM_UPDATE, TYPE_CHAT_SUCCESS } from "./chat.actionTypes";

export const initialChatState = {
  loading: false, 
  streaming: false,
  error: null,
  data: "",
  streamingText: "",
  history: [], 
  threadId: null,
  partialData: null,
  ragData: null,
  sessionData: null,
  allSessionsData: null
};

export const chatReducer = (state = initialChatState, action) => {
  switch (action.type) {
    case TYPE_CHAT_STREAM_START:
      return {
        ...initialChatState,
        loading: true,
        streaming: true,
        threadId: action.payload?.threadId ?? null,
      };

    case TYPE_CHAT_STREAM_UPDATE: {
      const chunk = action.payload?.chunk;
      if (!chunk) return state;
      return {
        ...state,
        streamingText: state.streamingText + chunk,
        threadId: action.payload?.threadId ?? state.threadId,
      };
    }

    case TYPE_CHAT_STREAM_META:
      return {
        ...state,
        threadId: action.payload?.threadId ?? state.threadId,
        history: action.payload?.history ?? state.history,
        questionData: action.payload?.question ?? state.questionData,
      };

    case TYPE_CHAT_SUCCESS:
      return {
        ...state,
        loading: false,
        streaming: false,
        error: null,
        data: action.payload?.data ?? state.streamingText,
        streamingText: "",
        history: action.payload?.history ?? state.history,
        questionData: action.payload?.questionData ?? state.questionData,
        threadId: action.payload?.threadId ?? state.threadId,
        partialData: null,
      };

    case TYPE_CHAT_FAILURE:
      return {
        ...state,
        loading: false,
        streaming: false,
        error: action.payload?.message || "Something went wrong.",
        partialData: action.payload?.partialData || state.streamingText || null,
        streamingText: "",
      };

    case TYPE_CHAT_RESET:
      return initialChatState;
    
    case RAG_UPLOAD_SUCCESS:
          return {
            ...state,
            ragData: action.payload,
          };
    case RAG_UPLOAD_FAILURE:
          return {
            ...state,
            message: "",
          };

    case GET_SESSION_DATA_SUCCESS:
          return {
            ...state,
            sessionData: action.payload,
          };
    case GET_SESSION_DATA_FAILURE:
          return {
            ...state,
            message: "",
          };

     case GET_ALL_SESSIONS_SUCCESS:
          return {
            ...state,
            allSessionsData: action.payload,
          };
     case GET_ALL_SESSIONS_FAILURE:
          return {
            ...state,
            message: "",
          };

    default:
      return state;
  }
}

